import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-503730a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Location", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Enter a city name, zip code, IP address or latitude/longitude.", -1))
const _hoisted_4 = { class: "callout mt-3 flex-column align-items-stretch" }
const _hoisted_5 = { class: "d-flex flex-grow-1 align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--callout",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8M3.05,13H1V11H3.05C3.5,6.83 6.83,3.5 11,3.05V1H13V3.05C17.17,3.5 20.5,6.83 20.95,11H23V13H20.95C20.5,17.17 17.17,20.5 13,20.95V23H11V20.95C6.83,20.5 3.5,17.17 3.05,13M12,5A7,7 0 0,0 5,12A7,7 0 0,0 12,19A7,7 0 0,0 19,12A7,7 0 0,0 12,5Z" })
], -1))
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "callout__location-label" }, "WEATHER FOR", -1))
const _hoisted_9 = {
  key: 0,
  style: {"color":"#424850"}
}
const _hoisted_10 = {
  key: 1,
  style: {"color":"#424850"}
}
const _hoisted_11 = { class: "item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Temperature Scale", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Refresh Interval", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Ditto refreshes the source every 10 minutes to ensure weather data is current.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Colors", -1))
const _hoisted_16 = { class: "d-flex flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    class: "weather-today-layout-editor mx-2",
    id: "WeatherThreeDayEditor",
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (_ctx.signageItemLayoutData.location.name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.signageItemLayoutData.location.name) + ", " + _toDisplayString(_ctx.signageItemLayoutData.location.region) + ", " + _toDisplayString(_ctx.signageItemLayoutData.location.country), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.signageItemLayoutData.location), 1))
                ]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  onClick: _ctx.onEditLocation,
                  class: "ms-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.editLocation ? 'Done' : 'Edit'), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_Transition, { name: "fade-down" }, {
                default: _withCtx(() => [
                  (_ctx.editLocation)
                    ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                        key: 0,
                        modelValue: _ctx.newLocation,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newLocation) = $event)),
                        "fetch-suggestions": _ctx.searchLocations,
                        onSelect: _ctx.handleLocationSelect,
                        style: {"padding-top":"1em"},
                        debounce: 1000,
                        placeholder: "Search City or Zip Code"
                      }, {
                        prefix: _withCtx(() => [
                          _createVNode(_component_Icon, { icon: _ctx.mdiMagnify }, null, 8, ["icon"])
                        ]),
                        default: _withCtx(({ item }) => [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(item.name) + ", " + _toDisplayString(item.region) + ", " + _toDisplayString(item.country), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "fetch-suggestions", "onSelect"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        })
      ]),
      _hoisted_12,
      _createVNode(_component_el_form_item, { class: "col-lg-6" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: _ctx.signageItemLayoutData.temperatureScale,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageItemLayoutData.temperatureScale) = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Fahrenheit",
                value: "Fahrenheit"
              }),
              _createVNode(_component_el_option, {
                label: "Celsius",
                value: "Celsius"
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_divider),
      _hoisted_13,
      _hoisted_14,
      _createVNode(_component_el_divider),
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_el_form_item, {
          class: "me-4",
          prop: "backgroundColor",
          label: "Background Color"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_color_picker, {
              class: "mt-1",
              modelValue: _ctx.signageItemLayoutData.backgroundColor,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.signageItemLayoutData.backgroundColor) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          prop: "fontColor",
          label: "Font Color"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_color_picker, {
              class: "mt-1",
              modelValue: _ctx.signageItemLayoutData.fontColor,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.signageItemLayoutData.fontColor) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["model"]))
}